const e=e=>typeof e==`object`&&!!e&&`permissions`in e;export{e as isPermissionGroup};
//# sourceMappingURL=is-permission-group.mjs.map